/**
 * PATH: packages/pricelist/src/PricelistRowMenus.tsx
 * FILE_ID: PKG-PRICELIST-ROW-MENUS-001
 * PURPOSE: Desktop floating row menu OR phone MobileActionSheet for row ops.
 * WHY: Touch has no reliable contextmenu; long-press opens a bottom sheet while
 *      desktop right-click keeps the existing floating RowContextMenu.
 */
import { MobileActionSheet } from '@quotech/ui/mobile'
import RowContextMenu from './RowContextMenu'
import { buildRowActionSheetItems } from './pricelistMobileMenus'

export interface PricelistRowMenuTarget {
  rowId: string
  x: number
  y: number
}

export interface PricelistRowMenusProps {
  /** Phone viewport → bottom sheet; desktop → floating menu. */
  isPhone: boolean
  target: PricelistRowMenuTarget | null
  onInsertAbove: (rowId: string) => void
  onInsertBelow: (rowId: string) => void
  onDuplicate: (rowId: string) => void
  onDelete: (rowId: string) => void
  onClose: () => void
}

export default function PricelistRowMenus({
  isPhone,
  target,
  onInsertAbove,
  onInsertBelow,
  onDuplicate,
  onDelete,
  onClose,
}: PricelistRowMenusProps) {
  if (!target) return null

  const actions = {
    onInsertAbove: () => onInsertAbove(target.rowId),
    onInsertBelow: () => onInsertBelow(target.rowId),
    onDuplicate: () => onDuplicate(target.rowId),
    onDelete: () => onDelete(target.rowId),
  }

  if (isPhone) {
    return (
      <MobileActionSheet
        open
        onClose={onClose}
        title="Row actions"
        items={buildRowActionSheetItems(actions)}
      />
    )
  }

  return (
    <RowContextMenu
      x={target.x}
      y={target.y}
      onInsertAbove={actions.onInsertAbove}
      onInsertBelow={actions.onInsertBelow}
      onDuplicate={actions.onDuplicate}
      onDelete={actions.onDelete}
      onClose={onClose}
    />
  )
}
